"use client";

import type { ReactNode } from "react";

interface FormInputProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /**
   * Discreet decoration rendered next to the label (right side). Used by
   * `UploadModal` to display the title-normalization "suggestion" badge.
   * Kept generic so other forms can reuse it.
   */
  labelAdornment?: ReactNode;
  /** When true, the input's value is rendered in italic, used to flag a "tentative" suggestion. */
  italicValue?: boolean;
}

export function FormInput({
  label,
  value,
  onChange,
  placeholder,
  labelAdornment,
  italicValue,
}: FormInputProps) {
  return (
    <div className="flex-1 flex flex-col gap-1">
      <div className="flex items-center justify-between gap-2 min-h-[14px]">
        <label className="text-[11px] font-medium text-text-muted uppercase tracking-wider">
          {label}
        </label>
        {labelAdornment ? (
          <span className="text-[10px] leading-none">{labelAdornment}</span>
        ) : null}
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`h-9 px-3 rounded-lg text-sm text-text-primary placeholder:text-text-muted/40 outline-none transition-all duration-150 ${italicValue ? "italic" : ""}`}
        style={{
          backgroundColor: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.06)",
        }}
        onFocus={(e) => { e.currentTarget.style.borderColor = "rgba(139,92,246,0.3)"; }}
        onBlur={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)"; }}
      />
    </div>
  );
}
